import { PageLocatorMap } from '../types/PageLocatorMap';

export const applyVehicleConditionPage = {
  footer: {
    root: 'apply-vehicle-condition-page.footer.root',
  },
  form: {
    h1: 'apply-vehicle-condition-page.form.h1',
    h2: 'apply-vehicle-condition-page.form.h2',
    radioGroupRoot: 'apply-vehicle-condition-page.form.radio-group-root',
    radioOption1: 'apply-vehicle-condition-page.form.radio-option-1',
    radioOption2: 'apply-vehicle-condition-page.form.radio-option-2',
    root: 'apply-vehicle-condition-page.form.root',
    submitButton: 'apply-vehicle-condition-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
